import {ShaderPrinter} from "./OwayoShaderSourceForSelObCreator";
import {THREE} from "../resource/three";
import {getRangeArray} from "../../global/arrayHelper";
import {rightCurry} from "../../global/functionalTools";
import {PartForMaterial} from "../owayoJSViewerWithSelObs";




export class OwayoShaderSourceForOverlayMapCreator extends ShaderPrinter {
    private static deltaVarName = "delta";
    private static nearColorVarName = "isNearColor";
    private static showOverlayVarName = "showOverlay";
    private static relCoordinate = (coord, dimension): string => p.divide(coord, p.getDimFunction(dimension)("overlayMapSize"));
    private static clampToMargins = (val, dimension): string => p.clamp(val, "0.0", p.getDimFunction(dimension)("overlayMapSize"));
    private static getcoordinate = (dimension: "x" | "y") => p.mod(
        p.getDimFunction(dimension)("posInOverlayMap"),
        p.getDimFunction(dimension)("overlayMapSize"),
    );
    private static getOverlayMapColor(part:PartForMaterial): string {

        return p.texture2D(
            "overlayMap",
            "vOriginalUv * vec2("+(part.partSizeCM.x / part.overlayScale.x).toFixed(2) + ", " + (part.partSizeCM.y / part.overlayScale.y).toFixed(2)+")"
            // p.vec2(
            //     p.relCoordinate(p.clampToMargins(p.getcoordinate("x"), "x"), "x"),
            //     p.relCoordinate(p.clampToMargins(p.getcoordinate("y"), "y"), "y")
            // )
        );
    }

    private static getDelta = (a,b)=>p.abs(p.subtract(a, b));
    private static getDeltaToColorResultVariable = (colorIntvalue: number, variableIndex) => {
        const rgb = new THREE.Color(colorIntvalue);
        return p.defineVec3var(
            p.append(variableIndex)(p.deltaVarName),
            p.getDelta("ColorResult.rgb", p.vec3(rgb.r, rgb.g, rgb.b))
        );
    }

    private static getIsNearColorBoolVariable = (variableIndex: number) => {
        const indexed = p.append(variableIndex);
        return p.defineBoolvar(
            indexed(p.nearColorVarName),
            p.allComponentsLessThan(indexed(p.deltaVarName), ["r", "g", "b"], 0.001)
        )
    }

    private static getShowOverlayBoolVariable = numberOfVariables => {
        const isNearColorVarwithIndex = rightCurry(p.append, p.nearColorVarName);
        return p.defineBoolvar(
            p.showOverlayVarName,
            p.or(getRangeArray(numberOfVariables).map(i => isNearColorVarwithIndex(i)))
        );
    }

    private static getShowOverlayVariables(overlayAnzeigenAufFarbenIntArray: number[]) {
        const deltas = overlayAnzeigenAufFarbenIntArray
            .map((intWert, i) => [p.getDeltaToColorResultVariable(intWert, i), p.getIsNearColorBoolVariable(i)].join(""))

        return [...deltas, p.getShowOverlayBoolVariable(overlayAnzeigenAufFarbenIntArray.length)].join("");
    }

    private static getShowOverlayCode(helligkeitsSummand, overlayIntensity, part:PartForMaterial) {
        return [
            p.assign("posInOverlayMap", p.times("overlayScalingMatrix", p.vec3("PixelPositioninOriginal", "1.0"))),
            p.assign("ColorTmp", p.getOverlayMapColor(part)),
            p.assign("ColorTmp.rgb", p.subtract("1.0", "ColorTmp.rgb")),
            p.assign(
                "ColorResult.rgb",
                p.add(
                    "ColorResult.rgb",
                    p.add(
                        helligkeitsSummand.toFixed(3),
                        p.times(
                            p.add("0.229*ColorTmp.r", "0.587*ColorTmp.g", "0.114*ColorTmp.b"),
                            overlayIntensity.toFixed(3)
                        )
                    )
                )
            )
            ].join("");
    }


    public static getShaderSource(helligkeitsSummand, overlayIntensity, overlayAnzeigenAufFarbenIntArray: number[], part:PartForMaterial) {
        /*
        Vorsicht!
        Stand: 2.11.2021
        in der Stoff JSON, in der das overlay definiert ist stehen auch Farben, für die diese Melierung angezeigt werden soll.
        Mit dieser Farbe wird hier verglichen und das Overlay angezeigt oder eben auch nicht.
        Sollte hier ein Designelement mit derselben Farbe in der Designtextur liegen wird auch dieses meliert!
        Abhilfe könnte ein Vergleich A={ColorCode farbe BW} bringen, analog zur Abfrage der owayo Logos.
         */
        if(overlayAnzeigenAufFarbenIntArray.length === 0) {
            return p.getShowOverlayCode(helligkeitsSummand, overlayIntensity, part);
        }

        return [
            p.getShowOverlayVariables(overlayAnzeigenAufFarbenIntArray),
            p.if(p.showOverlayVarName)(
                p.getShowOverlayCode(helligkeitsSummand, overlayIntensity, part)
            )
        ].join("");
    }
}

const p = OwayoShaderSourceForOverlayMapCreator;


